import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithBackground.js";
import { SectionHeading } from "components/misc/Headings";
import {useSelector} from "react-redux";
import translate from "../lang/translate";
import {LangProvider} from "../lang";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;

export default ({ headingText = translate('terms_condition.terms_condition') }) => {
  const locale = useSelector(state => state.locale);
  return (
      <LangProvider locale={locale}>
        <AnimationRevealPage>
          <Header />
          <Container>
            <ContentWithPaddingXl>
              <HeadingRow>
                <Heading>{headingText}</Heading>
              </HeadingRow>
              <Text>
                <div>
                  <h2>{translate('terms_condition.services.title')}</h2>
                  <p>
                    {translate('terms_condition.services.1')}
                  </p>
                  <p>
                    {translate('terms_condition.services.2')}
                  </p>
                  <p>
                    {translate('terms_condition.services.3')}
                  </p>
                  <p>
                    {translate('terms_condition.services.4')}
                  </p>
                  <p>
                    {translate('terms_condition.services.5')}
                  </p>
                </div>
                <div>
                  <h2>{translate('terms_condition.contact.title')}</h2>
                  <p>
                    {translate('terms_condition.contact.1')}
                  </p>
                  <p>
                    {translate('terms_condition.contact.2')}
                  </p>
                  <p>
                    {translate('terms_condition.contact.3')}
                  </p>
                  <p>
                    {translate('terms_condition.contact.4')}
                  </p>
                  <p>
                    {translate('terms_condition.contact.5')}
                  </p>
                  <p>
                    {translate('terms_condition.contact.6')}
                  </p>
                  <p>
                    {translate('terms_condition.contact.7')}
                  </p>
                </div>
                <div>
                  <h2>{translate('terms_condition.terms_payment.title')}</h2>
                  <p>
                    {translate('terms_condition.terms_payment.1')}
                  </p>
                  <p>
                    {translate('terms_condition.terms_payment.2')}
                  </p>
                  <p>
                    {translate('terms_condition.terms_payment.3')}
                  </p>
                  <p>
                    {translate('terms_condition.terms_payment.4')}
                  </p>
                  <p>
                    {translate('terms_condition.terms_payment.5')}
                  </p>
                  <p>
                    {translate('terms_condition.terms_payment.6')}
                  </p>
                  <p>
                    {translate('terms_condition.terms_payment.7')}
                  </p>
                </div>
                <div>
                  <h2>{translate('terms_condition.warraties.title')}</h2>
                  <p>
                    {translate('terms_condition.warraties.1')}
                  </p>
                  <p>
                    {translate('terms_condition.warraties.2')}
                  </p>
                  <p>
                    {translate('terms_condition.warraties.3')}
                  </p>
                  <p>
                    {translate('terms_condition.warraties.4')}
                  </p>
                  <p>
                    {translate('terms_condition.warraties.5')}
                  </p>
                  <p>
                    {translate('terms_condition.warraties.6')}
                  </p>
                  <p>
                    {translate('terms_condition.warraties.7')}
                  </p>
                  <p>
                    {translate('terms_condition.warraties.8')}
                  </p>
                  <p>
                    {translate('terms_condition.warraties.9')}
                  </p>
                  <p>
                    {translate('terms_condition.warraties.10')}
                  </p>
                  <p>
                    {translate('terms_condition.warraties.11')}
                  </p>
                  <p>
                    {translate('terms_condition.warraties.12')}
                  </p>
                  <p>
                    {translate('terms_condition.warraties.13')}
                  </p>
                </div>
                <div>
                  <h2>{translate('terms_condition.data_protection.title')}</h2>
                  <p>
                    {translate('terms_condition.data_protection.1')}
                  </p>
                  <p>
                    {translate('terms_condition.data_protection.2')}
                  </p>
                  <p>
                    {translate('terms_condition.data_protection.3')}
                  </p>
                  <p>
                    {translate('terms_condition.data_protection.4')}
                  </p>
                  <p>
                    {translate('terms_condition.data_protection.5')}
                  </p>
                  <p>
                    {translate('terms_condition.data_protection.6')}
                  </p>
                </div>
                <div>
                  <h2>{translate('terms_condition.user_res.title')}</h2>
                  <p>
                    {translate('terms_condition.user_res.1')}
                  </p>
                  <p>
                    {translate('terms_condition.user_res.2')}
                  </p>
                  <p>
                    {translate('terms_condition.user_res.3')}
                  </p>
                  <p>
                    {translate('terms_condition.user_res.4')}
                  </p>
                  <p>
                    {translate('terms_condition.user_res.5')}
                  </p>
                  <p>
                    {translate('terms_condition.user_res.6')}
                  </p>
                  <p>
                    {translate('terms_condition.user_res.7')}
                  </p>
                  <p>
                    {translate('terms_condition.user_res.8')}
                  </p>
                  <p>
                    {translate('terms_condition.user_res.9')}
                  </p>
                </div>
                <div>
                  <h2>{translate('terms_condition.copyright.title')}</h2>
                  <p>
                    {translate('terms_condition.copyright.1')}
                  </p>
                  <p>
                    {translate('terms_condition.copyright.2')}
                  </p>
                  <p>
                    {translate('terms_condition.copyright.3')}
                  </p>
                  <p>
                    {translate('terms_condition.copyright.4')}
                  </p>
                </div>
                <div>
                  <h2>{translate('terms_condition.cancellation.title')}</h2>
                  <p>
                    {translate('terms_condition.cancellation.1')}
                  </p>
                  <p>
                    {translate('terms_condition.cancellation.2')}
                  </p>
                  <p>
                    {translate('terms_condition.cancellation.3')}
                  </p>
                  <p>
                    {translate('terms_condition.cancellation.4')}
                  </p>
                  <p>
                    {translate('terms_condition.cancellation.5')}
                  </p>
                </div>
                <div>
                  <h2>{translate('terms_condition.final_condition.title')}</h2>
                  <p>
                    {translate('terms_condition.final_condition.1')}
                  </p>
                  <p>
                    {translate('terms_condition.final_condition.2')}
                  </p>
                  <p>
                    {translate('terms_condition.final_condition.3')}
                  </p>
                  <p>
                    {translate('terms_condition.final_condition.4')}
                  </p>
                  <p>
                    {translate('terms_condition.final_condition.5')}
                  </p>
                </div>
              </Text>
            </ContentWithPaddingXl>
          </Container>
          <Footer />
        </AnimationRevealPage>
      </LangProvider>
  );
};
